import React, { RefObject, useEffect, useState } from 'react';
import { styled } from '@glitz/react';
import { Sound34x24, SoundMuted34x24 } from 'Shared/Icons/Sound';
import Slider from 'Shared/SharedComponents/atoms/Slider';

type PropType = {
  mediaRef: RefObject<HTMLMediaElement>;
};

const Wrap = styled.div({
  position: 'relative', height: '100%', display: 'flex', alignItems: 'center', gap: '8px'
})

const Sound = styled(Sound34x24, {
  cursor: 'pointer'
})

const Muted = styled(SoundMuted34x24, {
  cursor: 'pointer'
})

const SoundControls = ({ mediaRef }: PropType) => {
  const [muted, setMuted] = useState(false);
  const [volume, setVolume] = useState(0);

  useEffect(() => {
    if (mediaRef?.current) {
      setMuted(mediaRef.current.muted);
      setVolume(mediaRef.current.volume);
    }
  }, [mediaRef]);

  const mute = () => {
    if (mediaRef?.current) {
      mediaRef.current.muted = true;
      setMuted(true);
    }
  };

  const unmute = () => {
    if (mediaRef?.current) {
      mediaRef.current.muted = false;
      setMuted(false);
      if (volume === 0) {
        setVolume(0.5);
      }
    }
  };

  const adjustVolume = (selectedVolume: number) => {
    let newVolume = Math.min(Math.max(selectedVolume, 0), 1);
    if (mediaRef?.current) {
      mediaRef.current.volume = newVolume;
      setVolume(newVolume);
      if (newVolume === 0) {
        setMuted(true);
      } else if (muted) {
        setMuted(false);
      }
    }
  };

  return (
    <Wrap>
      {muted ? (
        <Muted onClick={unmute} />
      ) : (
        <Sound onClick={mute} />
      )}
      <Slider
        min={0}
        max={48}
        value={muted ? 0 : 48 * volume}
        updateValue={(selectedValue) => {
          adjustVolume(selectedValue / 48);
        }}
        width={48}
      />
    </Wrap>
  );
};

export default SoundControls;
